import config from '../config/config';
import { enGB, enUS, fr, de } from 'date-fns/locale';

const defaultLocale = config.defaultLocale;

// Map locale strings to date-fns locales
export const localeMap = {
  'en-IN': enGB, // Map en-IN to enGB as the closest approximation
  'en-GB': enGB,
  'en-US': enUS,
  'fr': fr,
  'de': de,
  // Add other locales as needed
};


export const formatDate = (date, locale = defaultLocale, options = { day: '2-digit', month: '2-digit', year: 'numeric' }) => {
  return new Intl.DateTimeFormat(locale, options).format(new Date(date));
};

export const formatNumber = (number, locale = defaultLocale, options = { maximumFractionDigits: 2 }) => {
  return new Intl.NumberFormat(locale, options).format(number);
};

export const formatCurrency = (amount, locale = defaultLocale, currency = 'INR', options = { style: 'currency', currency }) => {
  return new Intl.NumberFormat(locale, options).format(amount);
};